<template>
  <div class="custom-table">
    <div v-if="signatories" class="table-responsive">
      <table v-if="!loaded" class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800">
        <thead>
        <tr class="align-middle bg-gray-100i">
          <td colspan="8" class="text-center">
            <div
                @click="addSignatory('Подписант')"
                class="rounded border border-dashed pt-6 pb-6 cursor-pointer text-gray-400 border-gray-300 text-hover-primary border-hover-primary"
                style="border-width: 1px;">Добавить</div>
          </td>
        </tr>
        <tr class="fw-bold fs-8 text-gray-400">
          <th>ID</th>
          <th>ИИН</th>
          <th>Ф.И.О</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in signatories" :key="item.id">
          <td v-html="item.id"></td>
          <td v-html="item.iin"></td>
          <td v-html="item.title"></td>
          <td class="text-end">
            <span
                v-if="item.status === 1"
                @click="signatoryChange(item.id, 2)"
                title="Заблокировать"
                class="employee__tree-disabled cursor-pointer">
              <i class="ki-outline ki-minus-square fs-4 text-warning"></i>
            </span>
            <template v-else>
              <span
                  @click="signatoryChange(item.id, 1)"
                  title="Активировать"
                  class="employee__tree-add ms-1 cursor-pointer">
              <i class="ki-outline ki-check-square fs-4 text-primary"></i>
            </span>
              <span
                  @click="signatoryChange(item.id, 0)"
                  title="Удалить"
                  class="employee__tree-disabled ms-1 cursor-pointer">
              <i class="ki-outline ki-cross-square fs-4 text-danger"></i>
            </span>
            </template>
          </td>
        </tr>
        </tbody>
      </table>
      <loader-full style="min-height: 200px" v-else/>
    </div>
  </div>
</template>

<script>
import LoaderFull from '@/components/Main/LoaderFull';
import axios      from 'axios';

export default {
  name: 'BranchSignatoriesTable',
  components: {LoaderFull},
  props: {
    signatories: null
  },
  data() {
    return {
      loaded: false
    }
  },
  methods: {
    addSignatory(title) {
      this.$store.dispatch('branchSignatoryAddByOneCModel', {title:title});
      new bootstrap.Modal('#BranchSignatoryAddByOneCModel', {}).show()
    },
    signatoryChange(id, status) {
      this.loaded   = true
      let confirmed = true
      if (status === 0) confirmed = confirm('Удалить')
      if (confirmed) {
        const data = {status:status, id:id}
        axios.post('/api/branches/change-signatory', data)
            .then(res => {
              if (res.data.result) {
                this.$store.dispatch('signatoriesRequest')
              } else {
                this.$notifyError(res.data)
              }
            })
            .catch(err => {
              this.$notifyError(err)
            })
            .finally(() => this.loaded = false)
      }
      if (!confirmed) this.loaded = false
    }
  }
}
</script>

<style scoped>

</style>